import { SVGProps, Ref, forwardRef } from 'react';

export const CheckDoubleOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path d="m11.01 3.5-7.02 7.02-3-3-.99.99 3.99 3.99L12 4.49z" fill="currentColor" />
            <path d="m15.01 3.5.99.99-8.01 8.01-.99-.99z" fill="currentColor" />
        </g>
    </svg>
));
CheckDoubleOutlinedSize16Glyph.displayName = 'CheckDoubleOutlinedSize16Glyph';
